<template>
  <button
    class="iDalgo-Button"
    @click="handleClick"
    :class="{
      'disabled': disabled,
      'loading': loading
      }"
    >
    <span class="iDalgo-Button__Content">
      <slot></slot>
    </span>
    <span class="iDalgo-Button__Loader" v-show="loading">
      <svgicon name="loading" :original="true"></svgicon>
    </span>
  </button>
</template>

<script>
import '@/components/icons'
export default {
  name: 'iDalgo-Button',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Button {
  border-radius: 2px;
  border: none;
  padding: 8px 44px 6px 44px;
  font-size: 19px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  background-color: #229221;

  &.disabled {
    background-color: #737373;
    cursor: not-allowed;
  }

  &:hover {
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
  }

  &.loading {
    background-color: #229221 !important;
    cursor: not-allowed !important;
  }

  &__Content {
    font-family: "source_sans_prosemibold", sans-serif !important;
    color: #FFFFFF !important;
    text-align: center;

    .loading & {
      opacity: 0;
    }
  }

  &__Loader {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
      fill: #000;
      animation: rotating 1s linear infinite;
    }
  }
}

@keyframes rotating {
from {
  transform: rotate(0deg);
} to {
  transform: rotate(360deg);
}
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Button.vue